import { FC } from 'react'

import { Icon } from './types'

export const ResignIcon: FC<Icon> = ({ className }) => {
  return (
    <svg className={className} viewBox="0 0 24 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_54_834)">
        <path
          d="M7.63061 10.4748C9.22018 10.4748 10.5088 9.19871 10.5088 7.62457C10.5088 6.05042 9.22018 4.77433 7.63061 4.77433C6.04104 4.77433 4.75244 6.05042 4.75244 7.62457C4.75244 9.19871 6.04104 10.4748 7.63061 10.4748Z"
          fill="white"
        />
        <path
          d="M23.399 0.949669C23.2022 0.779142 22.9316 0.730419 22.6856 0.803503C21.3326 1.14456 20.324 0.852225 19.1678 0.51117C17.9379 0.145754 16.5603 -0.244022 14.7645 0.194477C14.3955 0.291921 14.1249 0.632975 14.1249 0.998391V14.4457H13.2639L11.1975 12.2045C10.6071 11.5467 9.74614 11.1813 8.86055 11.1813H6.54817C5.51498 11.1813 4.53099 11.6929 3.9406 12.5455L0.595034 17.3934C0.299837 17.8319 0.226038 18.4165 0.521235 18.8794C0.791832 19.2692 1.21003 19.4641 1.60362 19.4641C2.02182 19.4641 2.41542 19.2692 2.66141 18.9038L4.38339 16.3946V19.1717C4.38339 19.6346 4.75239 20 5.21979 20H9.96754C10.4349 20 10.8039 19.6346 10.8039 19.1717V15.615L11.6895 16.5895C11.9355 16.8574 12.2799 17.0036 12.6489 17.0036H14.0757V19.123C14.0757 19.5859 14.4447 19.9513 14.9121 19.9513C15.3795 19.9513 15.7485 19.5859 15.7485 19.123V16.9792C16.3635 16.9305 16.9047 16.5164 17.0031 15.9073C17.1261 15.1034 16.5111 14.4457 15.7485 14.4213V7.57587C16.8063 7.45407 17.6673 7.69768 18.6266 7.99001C19.463 8.23362 20.3732 8.50159 21.431 8.50159C21.923 8.50159 22.4396 8.45287 23.0054 8.3067C23.3744 8.20926 23.645 7.8682 23.645 7.50279V1.63178C23.7188 1.33945 23.5958 1.09584 23.399 0.949669Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_54_834"
          x="0.333313"
          y="0"
          width="23.3333"
          height="21"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_54_834" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_54_834" result="shape" />
        </filter>
      </defs>
    </svg>
  )
}
